<div class="heading-text-component-wrapper">
  @if(textIcon) {
    <img src="{{textIcon}}" alt="text icon" />
  }

  <h3>{{headingText}}</h3>

  <p>{{bodyText}}</p>
</div>
